import React from "react";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components/";
import { _Autocomplete, _DateField, _Select } from "../../form/";

interface IGeneralDetailsProps {
    Data: Dati.CRisAPIDatoTipiInfo_Anag;
    GetFieldValidation: (field: string) => boolean;
    GetFieldValidationMessage: (field: string) => string;
    OnChange: (e: React.FormEvent<any> | string, val?: unknown) => void;
    OnChangeDetailsType: (valore: string) => void;
}

export const _GeneralDetails: React.FC<IGeneralDetailsProps> = ({ Data, GetFieldValidation, GetFieldValidationMessage, OnChange, OnChangeDetailsType }) => {
    const formData = Data.Dato;
    const isLegalPerson = [Glob.Tipi_TAP_PersonaGiuridica, Glob.Tipi_TAP_ATI, Glob.Tipi_TAP_Beneficiario].includes(formData.ID_TipoAnagPrincipale);
    const isPhysicalPerson = [Glob.Tipi_TAP_PersonaFisica].includes(formData.ID_TipoAnagPrincipale);
    //const isFirm = [Glob.Tipi_TAP_PersonaGiuridica, Glob.Tipi_TAP_ATI, Glob.Tipi_TAP_Beneficiario].includes(formData.ID_TipoAnagPrincipale);
    const isDittaIndividuale = [Glob.Tipi_TAP_DittaIndividuale].includes(formData.ID_TipoAnagPrincipale);

    //const isFiscalCodeNotValid = GetFieldValidation("CodiceFiscale");
    //const fiscalCodeValidationMessage = GetFieldValidationMessage("CodiceFiscale");

    let Sessione = Glob.GetSessione();
    const isCS = Sessione.Gruppi.includes("CS");

    return (
        <Grid container spacing={4}>
            <Grid item xs={12} md={2}>
                <TextField fullWidth id="Dato.ID_Anag" label={Trad.Trad("ID")} value={formData.ID_Anag} disabled />
            </Grid>
            <Grid item xs={12} md={2}>
                <_Select Value={formData.ID_TipoAnagStato} Name="Dato.ID_TipoAnagStato" Label="Stato" OnChange={OnChange} Options={Data.Tipi["TipiAnagStati"] || {}} Disabled={true} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_Select
                    Value={formData.ID_TipoAnagPrincipale || ""}
                    Name="Dato.ID_TipoAnagPrincipale"
                    Label="Tipo Anagrafica"
                    OnChange={(e, val) => {
                        OnChange(e, val);
                        OnChangeDetailsType(val);
                    }}
                    Options={Data.Tipi["TipiAnagPrincipale"] || {}}
                />
            </Grid>
            {(isLegalPerson) && (
                <>
                    <Grid item xs={12} md={2}>   
                        <TextField fullWidth
                            error={GetFieldValidation("RagioneSociale")}
                            helperText={GetFieldValidationMessage("RagioneSociale")}
                            id="Dato.RagioneSociale" label={Trad.Trad("Ragione Sociale")}
                            value={formData.RagioneSociale || ""}
                            onChange={e => {
                                e.currentTarget.value = Glob.CapitalizeFirstLetter(e.currentTarget.value);
                                OnChange(e);
                            }} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <_Autocomplete
                            SearchInput
                            Value={formData.ID_TipoSocieta}
                            Name="Dato.ID_TipoSocieta"
                            Label="Tipo Società"
                            OnChange={OnChange}
                            Url="/api/Tipi/Tipo?tabella=TipiSocieta&campo=TipoSocieta"
                        />
                    </Grid>
                    {Glob.AzioneAbilitata("CapogruppoAnag", Glob.Lettura) && (
                        <Grid item xs={12} md={3}>
                            <_Autocomplete
                                Value={formData.ID_AnagCapoGruppo}
                                Name="Dato.ID_AnagCapoGruppo"
                                Label="Capogruppo"
                                OnChange={OnChange}
                                Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                            />
                        </Grid>
                    )}
                </>
            )}
            {(isPhysicalPerson || isDittaIndividuale) && (
                <>
                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth
                            error={GetFieldValidation("Nome")}
                            helperText={GetFieldValidationMessage("Nome")}
                            id="Dato.Nome"
                            label={Trad.Trad("Nome")}
                            value={formData.Nome || ""}
                            onChange={e => {
                                e.currentTarget.value = Glob.CapitalizeFirstLetter(e.currentTarget.value);
                                OnChange(e);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth
                            error={GetFieldValidation("Cognome")}
                            helperText={GetFieldValidationMessage("Cognome")}
                            id="Dato.Cognome"
                            label={Trad.Trad("Cognome")}
                            value={formData.Cognome || ""}
                            onChange={e => {
                                e.currentTarget.value = Glob.CapitalizeFirstLetter(e.currentTarget.value);
                                OnChange(e);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <_DateField
                            Value={formData.DataNascita}
                            Name="Dato.DataNascita"
                            Label="Data nascita"
                            OnChange={OnChange}
                            required={true}/>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            error={GetFieldValidation("LuogoNascita")}
                            helperText={GetFieldValidationMessage("LuogoNascita")}
                            id="Dato.LuogoNascita"
                            label={Trad.Trad("Luogo nascita")}
                            value={formData.LuogoNascita || ""}
                            onChange={e => {
                                e.currentTarget.value = Glob.CapitalizeFirstLetter(e.currentTarget.value);
                                OnChange(e);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl component="fieldset" defaultValue="F">
                            <FormLabel component="legend">Gender</FormLabel>
                            <RadioGroup row aria-label="gender" name="Dato.Sesso" value={formData.Sesso || ""} onChange={OnChange}>
                                <FormControlLabel value="F" control={<Radio />} label={Trad.Trad("Femmina")} />
                                <FormControlLabel value="M" control={<Radio />} label={Trad.Trad("Maschio")} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </>
            )}
                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth
                            error={GetFieldValidation("CodiceFiscale")}
                            helperText={GetFieldValidationMessage("CodiceFiscale")}
                            id="Dato.CodiceFiscale"
                            label={Trad.Trad("CF")}
                            value={formData.CodiceFiscale || ""}
                            onChange={e => {
                                e.currentTarget.value = e.currentTarget.value.toUpperCase();
                                OnChange(e);
                            }}
                        />
                    </Grid>
            {(isPhysicalPerson) && (
                <>
                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth
                            id="Dato.DocNumber"
                            label={Trad.Trad("Numero documento")}
                            value={formData.DocNumber || ""}
                            onChange={e => {
                                e.currentTarget.value = Glob.CapitalizeFirstLetter(e.currentTarget.value);
                                OnChange(e);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth
                            id="Dato.DocIssuedBy"
                            label={Trad.Trad("Rilasciato da")}
                            value={formData.DocIssuedBy || ""}
                            onChange={e => {
                                e.currentTarget.value = Glob.CapitalizeFirstLetter(e.currentTarget.value);
                                OnChange(e);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <_DateField
                            Value={formData.DocIssuedOn}
                            Name="Dato.DocIssuedOn"
                            Label="Rilasciato in data"
                            OnChange={OnChange}
                            required={false}
                            />
                    </Grid>
                </>
            )}
            {(isLegalPerson || isDittaIndividuale) && (
                <>
                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth
                            error={GetFieldValidation("PartitaIVA")}
                            helperText={GetFieldValidationMessage("PartitaIVA")}
                            id="Dato.PartitaIVA"
                            label={Trad.Trad("PIVA")}
                            value={formData.PartitaIVA || ""}
                            onChange={OnChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                                <_Autocomplete
                                    Value={formData.ID_AnagLegaleRappresentante}
                                    Name="Dato.ID_AnagLegaleRappresentante"
                                    Label="Legale Rappresentante"
                                    OnChange={OnChange}
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                />
                            </Grid>
                 </>
            )}
            {isCS && (
                <>
                    <Grid item xs={12} md={3}>
                        <_Autocomplete
                            Value={formData.ID_AnagAppartenenza}
                            Name="Dato.ID_AnagAppartenenza"
                            Label="Appartenenza"
                            OnChange={OnChange}
                            Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/ClientDetails/GeneralDetails.tsx